import clsx from 'clsx'
import { useState } from 'react'

import bonusIcon from 'assets/svg/bonus.svg'
import starFill from 'assets/svg/starFill.svg'

import { Button, Modal } from '@/shared/ui'
import { Icon } from '@/shared/ui/icon'

import { ProductReviewsResponse } from '../../model/types'
import { Stars } from '../stars/Stars'

import styles from './RatingSummary.module.scss'

export const RatingSummary = ({
	data,
	isProductUnavailable,
	onCreateReview,
	hideCreateReviewButton = false,
	hideBonusButton = false
}: {
	data: ProductReviewsResponse['summary']
	isProductUnavailable?: boolean
	onCreateReview: () => void
	hideCreateReviewButton?: boolean
	hideBonusButton?: boolean
}) => {
	const maxCount = Math.max(...data.distribution.map(item => item.count), 1)
	const [isBonusesModalOpen, setIsBonusesModalOpen] = useState(false)

	return (
		<>
			<div className={clsx(styles.reviewsCard, { [styles.reviewsCardUnavailable]: isProductUnavailable })}>
				<div className={styles.reviewsBody}>
					<div className={styles.ratingHeadline}>
						<div className={styles.ratingValue}>
							<strong>{data.average.toFixed(1)}</strong>
							{!hideBonusButton && (
								<button
									type="button"
									className={styles.bonusButton}
									aria-label="Открыть информацию о бонусах за отзывы"
									onClick={() => setIsBonusesModalOpen(true)}>
									<Icon className={styles.bonusIcon} icon={bonusIcon} width={24} height={24} />
								</button>
							)}
						</div>
						<div className={styles.ratingStars}>
							<Stars rating={data.average} size="medium" />
							<span className={styles.ratingTotal}>Всего оценок: {data.total}</span>
						</div>
					</div>

					<div className={styles.ratingBars}>
						{data.distribution.map(item => (
							<div key={item.rating} className={styles.ratingBarRow}>
								<span>
									<Icon icon={starFill} className={styles.ratingBarStar} /> {item.rating}
								</span>
								<i>
									<span style={{ width: `${(item.count / maxCount) * 100}%` }} />
								</i>
								<small>{item.count}</small>
							</div>
						))}
					</div>
				</div>

				{!hideCreateReviewButton && (
					<Button theme="outlined-primary" fullWidth onClick={onCreateReview}>
						Написать отзыв
					</Button>
				)}

				{!!data.criteria.length && (
					<div className={styles.criteria}>
						{data.criteria.map(({ name, rating }) => (
							<div key={name}>
								<span>{name}</span>
								<Stars rating={rating} />
							</div>
						))}
					</div>
				)}
			</div>

			<Modal
				contentClassName={styles.bonusesModal}
				isOpen={isBonusesModalOpen}
				onClose={() => setIsBonusesModalOpen(false)}>
				<iframe className={styles.bonusesContent} src="/services/iport-card/" title="Бонусы за отзывы" />
			</Modal>
		</>
	)
}
